import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";

import {
  LOBS_LIST,
  CAN_I_DISABLE_LOB,
  ADMIN_LOCATIONS_LIST,
  COUNTRIES_BY_CLIENT,
} from "../../GraphQL/Queries";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PortalModal from "../../Portals";
import {
  GeneralStyle,
  TableConvention,
  TableViewButton,
  SearchField,
  ActionSection,
  useStyles,
} from "./DataManagementList.styled";
import { theme as themeConfig } from "../../themes/themes";
import SearchIcon from "@material-ui/icons/Search";
import { Form, Row, Col } from "react-bootstrap";
import { clientPolicyIngsight } from "../../App";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import ModalLoader from "../ModalLoader/ModalLoader";
import LobCreationForm from "../LobCreationForm/LobCreationForm";
import SitesCreationForm from "../SitesCreationForm";
import { ROLES } from "../../util/RolesConstants";
import {
  DELETE_LOB,
  UPDATE_LOB_STATUS,
  CHANGE_LOCATION_STATUS,
} from "../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import TablePagination from "@material-ui/core/TablePagination";
import { AntSwitch } from "../../helpers/antSwitch";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import PropTypes from "prop-types";

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const DataManagementList = ({
  activeLob,
  activeSite,
  reloadRender,
  setReloadRender,
  formTrigger,
  setFormTrigger,
  valueTab,
}) => {
  const [userComplete] = useState(getStateLoginComplete());
  const [dataList, setDataList] = useState([]);
  const classes = useStyles();
  const [alert, setAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const [user] = useState(getStateLoginComplete());
  const [titleOfTable, setTitleOfTable] = useState();
  const [identity, setIdentity] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [showCards, setShowCards] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [editRowData, setEditRowData] = useState();
  const [
    updateLobStatus,
    { loading: loadingUpdateLobStatus, error: errorUpdateLobStatus },
  ] = useMutation(UPDATE_LOB_STATUS);
  const [
    changeStatusLocation,
    { loading: loadingChangeStateSite, error: errorChangeStateSite },
  ] = useMutation(CHANGE_LOCATION_STATUS);
  const [deleteLob, { loading: loadingDeleteLob, error: errorDeleteLob }] =
    useMutation(DELETE_LOB);
  const [country, setCountryValue] = useState([]);
  const [searchTxt, setSearchTxt] = useState("");
  const [allPages, setAllPages] = useState(null);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowsPerPageOptions] = useState([5, 10, 25]);
  const [renderAgain, setrenderAgain] = useState(false);
  const [columns, setColumns] = useState([]);
  const { data: countries } = useQuery(COUNTRIES_BY_CLIENT, {
    variables: { clientId: user.clientId },
    context: { clientName: "LinkUsers" },
  });

  const [runQueryCanIDisableLob, { loading: loadingCanIDisableLobs }] =
    useLazyQuery(CAN_I_DISABLE_LOB, {
      fetchPolicy: "cache-and-network",
      client: clientPolicyIngsight,
    });

  const [
    runQueryLocationsList,
    { loading: loadingLocations, error: errorLocations },
  ] = useLazyQuery(ADMIN_LOCATIONS_LIST, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      assignLocationsData(data);
    },
  });

  const [runQueryLobsList, { loading: loadingLobsList, error: errorLobsList }] =
    useLazyQuery(LOBS_LIST, {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        asignLobsData(data);
      },
    });

  const assignLocationsData = (data) => {
    setAllPages(data?.locationsAdminList?.totalCount);
    if (data?.locationsAdminList?.pageInfo?.hasNextPage === true) {
      setEndCursor(data?.locationsAdminList?.pageInfo?.endCursor);
    }
    if (data?.locationsAdminList?.pageInfo?.hasPreviousPage === true) {
      setStartCursor(data?.locationsAdminList?.pageInfo?.startCursor);
    }
    let locationsAdminList = data.locationsAdminList.nodes.map((element) => {
      return {
        locationId: element.cityId,
        statusId: element.enabled,
        country: element.countryName,
        city: element.cityName,
        cityId: element.cityId,
        createUser: element.createUser,
        createDate: moment(element.createDate).format("DD/MM/YYYY"),
      };
    });

    if (
      data?.locationsAdminList?.nodes &&
      Array.isArray(data.locationsAdminList.nodes) &&
      data.locationsAdminList.nodes.length > 0
    ) {
      setDataList(locationsAdminList);
    } else {
      setDataList([]);
    }
  };

  const asignLobsData = (data) => {
    setAllPages(data?.lobsAdminList?.totalCount);
    if (data?.lobsAdminList?.pageInfo?.hasNextPage === true) {
      setEndCursor(data?.lobsAdminList?.pageInfo?.endCursor);
    }
    if (data?.lobsAdminList?.pageInfo?.hasPreviousPage === true) {
      setStartCursor(data?.lobsAdminList?.pageInfo?.startCursor);
    }
    let lobsAdminList = data.lobsAdminList.nodes
      .map((element) => {
        return {
          lobid: element.lobId,
          name: element.lobName,
          description: element.lobDescription,
          countryName: element.country.countryName,
          createDate: moment(element.createDate).format("DD/MM/YYYY"),
          createUser: element.createName,
          statusId: element.enabled,
          usersInLob: "element.usersAssigned",
        };
      })
      .sort((a, b) => {
        return b.lobid - a.lobid;
      });
    if (
      data?.lobsAdminList?.nodes &&
      Array.isArray(data.lobsAdminList.nodes) &&
      data.lobsAdminList.nodes.length > 0
    ) {
      setDataList(lobsAdminList);
    } else {
      setDataList([]);
    }
  };

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      if (activeSite) {
        runQueryLocationsList({
          variables: {
            first: rowsPerPage,
            after: endCursor,
            searchBy: searchTxt,
          },
          context: { clientName: "LinkUsers" },
        });
      } else if (activeLob) {
        runQueryLobsList({
          variables: {
            countriesId: country,
            first: rowsPerPage,
            after: endCursor,
            searchBy: searchTxt,
          },
          context: { clientName: "LinkUsers" },
        });
      }
    }
    if (newPage < page) {
      if (activeSite) {
        runQueryLocationsList({
          variables: {
            last: rowsPerPage,
            before: startCursor,
            searchBy: searchTxt,
          },
          context: { clientName: "LinkUsers" },
        });
      } else if (activeLob) {
        runQueryLobsList({
          variables: {
            countriesId: country,
            last: rowsPerPage,
            before: startCursor,
            searchBy: searchTxt,
          },
          context: { clientName: "LinkUsers" },
        });
      }
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    let newRowsPerPage = event?.target?.value
      ? parseInt(event.target.value)
      : 10;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const deleteSite = (rowData) => {
    setReloadRender(true);
    changeStatusLocation({
      variables: {
        cityId: rowData.cityId,
        newStatus: "DELETED",
      },
      context: { clientName: "LinkUsers" },
    })
      .then((response) => {
        if (response?.data?.changeStatusLocation?.cityId) {
          NotificationManager.success(
            "This location has been deleted",
            "",
            5000
          );
          setOpenDeleteModal(null);
          setReloadRender(false);
        } else {
          NotificationManager.error(response?.errors[0]?.message, "", 5000);
          setOpenDeleteModal(null);
        }
      })
      .catch((error) => {
        //
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleDeleteLob = (rowData) => {
    setReloadRender(true);
    runQueryCanIDisableLob({
      variables: {
        lobId: rowData.lobid,
      },
    }).then((response) => {
      if (response.data.canIDisableLob) {
        deleteLob({
          variables: {
            lobId: rowData.lobid,
            newStatus: "DELETED",
          },
          context: { clientName: "LinkUsers" },
        })
          .then((response) => {
            let err = response.data.changeStatusLob.message;
            if (response.data.changeStatusLob?.lobId) {
              NotificationManager.success(
                "This lob has been deleted",
                "",
                5000
              );
              setOpenDeleteModal(null);
              setReloadRender(false);
            } else {
              NotificationManager.error(err.message, "", 5000);
              setOpenDeleteModal(null);
            }
          })
          .catch((error) => {
            //
            const errorMessage = error.message.split("\n")[0];
            setAlert(errorMessage);
          });
      } else {
        NotificationManager.warning(
          "The lob cannot be deleted, as it is assigned to one or more users.",
          "",
          5000
        );
      }
    });
  };

  let handleEdit = (rowData) => {
    if (activeLob) {
      setEditRowData(rowData);
      setFormTrigger("lobUpdate");
    }
    if (activeSite) {
      setEditRowData(rowData);
      setFormTrigger("location");
    }
  };

  let handleOptionsForDelete = (data) => {
    if (activeLob) {
      handleDeleteLob(data);
    }
    if (activeSite) {
      deleteSite(data);
    }
  };

  useEffect(() => {
    if (activeLob && searchTxt === "" && Array.isArray(country) && country.length === 0) {
      setSearchTxt("");
      setCountryValue([]);
      runQueryLobsList({
        variables: {
          countriesId: [],
          first: rowsPerPage,
          searchBy: "",
        },
        context: { clientName: "LinkUsers" },
      });
    }
    if (activeSite && searchTxt === "") {
      setSearchTxt("");
      setCountryValue([]);
      runQueryLocationsList({
        variables: {
          first: rowsPerPage,
          searchBy: "",
        },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [activeLob, activeSite, rowsPerPage, reloadRender]);

  useEffect(() => {
    if (
      (activeLob && Array.isArray(country) && country.length > 0) ||
      (activeLob && searchTxt !== "")
    ) {
      runQueryLobsList({
        variables: {
          countriesId: country,
          first: rowsPerPage,
          searchBy: searchTxt,
        },
        context: { clientName: "LinkUsers" },
      });
    }
    if (activeSite && searchTxt !== "") {
      runQueryLocationsList({
        variables: {
          first: rowsPerPage,
          searchBy: searchTxt,
        },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [searchTxt, country, rowsPerPage, activeLob, activeSite, reloadRender]);

  useEffect(() => {
    if (activeSite) {
      setIdentity("site-list");
      setTitleOfTable("Location List");
      setColumns([
        {
          title: "Id",
          field: "locationId",
          type: "string",
        },
        {
          title: "Country",
          field: "country",
          type: "string",
        },
        {
          title: "City",
          field: "city",
          type: "string",
        },
        {
          title: "Create Date",
          field: "createDate",
          type: "string",
        },
        {
          title: "Disable",
          field: "disabled",
          type: "string",
          sorting: false,
          render: (rowData) => (
            <FormControlLabel
              control={
                <AntSwitch
                  size="small"
                  checked={rowData?.statusId}
                  onChange={() => toggleChecked(rowData)}
                />
              }
            />
          ),
        },
        {
          title: "Delete",
          field: "delete",
          sorting: false,
          render: (rowData) =>
            rowData && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Tooltip title="Delete">
                    <IconButton
                      className={classes.active}
                      disabled={rowData?.statusId}
                      onClick={() => {
                        setAnchorEl(null);
                        setAnchorSelected(null);
                        setOpenDeleteModal(rowData);
                      }}
                    >
                      <DeleteTwoTone />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            ),
        },
      ]);
    } else if (activeLob) {
      setIdentity("lob-list");
      setTitleOfTable("LOB List");
      setColumns([
        {
          title: "Id",
          field: "lobid",
          type: "string",
        },
        {
          title: "LOB",
          field: "name",
          type: "string",
        },
        {
          title: "Country",
          field: "countryName",
          type: "string",
        },
        {
          title: "Created by",
          field: "createUser",
          type: "string",
        },
        {
          title: "Created Date",
          field: "createDate",
          type: "string",
        },
        {
          title: "Disable",
          field: "disabled",
          type: "string",
          sorting: false,
          render: (rowData) => (
            <FormControlLabel
              control={
                <AntSwitch
                  size="small"
                  checked={rowData?.statusId}
                  onChange={() => toggleChecked(rowData)}
                />
              }
            />
          ),
        },
        {
          title: "Actions",
          field: "actions",
          sorting: false,
          render: (rowData) =>
            rowData && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Tooltip title="Edit">
                    <IconButton
                      className={classes.active}
                      onClick={() => {
                        setAnchorEl(null);
                        setAnchorSelected(null);
                        handleEdit(rowData);
                      }}
                    >
                      <EditTwoTone />
                    </IconButton>
                  </Tooltip>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Tooltip title="Delete">
                    <IconButton
                      className={classes.active}
                      disabled={rowData?.statusId}
                      onClick={() => {
                        setAnchorEl(null);
                        setAnchorSelected(null);
                        setOpenDeleteModal(rowData);
                      }}
                    >
                      <DeleteTwoTone />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            ),
        },
      ]);
    }
  }, [activeLob, activeSite]);

  let toggleCheckedSite = (rowData) => {
    setReloadRender(true);
    changeStatusLocation({
      variables: {
        cityId: rowData.cityId,
        newStatus: rowData.statusId ? "DISABLED" : "ENABLED",
      },
      context: { clientName: "LinkUsers" },
    })
      .then((response) => {
        if (response?.data?.changeStatusLocation?.cityId) {
          NotificationManager.success(
            "The location status has been updated",
            "",
            5000
          );
          setReloadRender(false);
        } else {
          NotificationManager.error(response?.errors[0]?.message, "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleCountryChange = (event) => {
    const selectedCountryId = event.target.value;
    const parsedCountryId = parseInt(selectedCountryId);
    const selectedCountryIdArray = Number.isNaN(parsedCountryId)
      ? []
      : [parsedCountryId];
    setCountryValue(selectedCountryIdArray);
  };

  let toggleCheckedLob = (rowData) => {
    setReloadRender(true);
    let lobid = editRowData?.lobid ? editRowData?.lobid : rowData.lobid;
    runQueryCanIDisableLob({
      variables: {
        lobId: lobid,
      },
    })
      .then((response) => {
        if (response.data.canIDisableLob) {
          updateLobStatus({
            variables: {
              lobId: lobid,
              enabled: rowData.statusId ? "DISABLED" : "ENABLED",
            },
            context: { clientName: "LinkUsers" },
          })
            .then((response) => {
              if (response.data.changeStatusLob?.lobId) {
                NotificationManager.success(
                  "The lob status has been updated",
                  "",
                  5000
                );
                setReloadRender(false);
              } else {
                if (response.errors[0]?.message) {
                  NotificationManager.error(
                    response.errors[0]?.message,
                    "",
                    5000
                  );
                } else {
                  NotificationManager.error(
                    "Something went wrong in updating lob status",
                    "",
                    5000
                  );
                }
              }
            })
            .catch((error) => {
              //
              const errorMessage = error.message.split("\n")[0];
              NotificationManager.error(errorMessage, "", 5000);
            });
        } else {
          NotificationManager.warning(
            "The status of this lob cannot be changed, as it is assigned to one or more users.",
            "",
            5000
          );
        }
      })
      .catch((error) => {
        //
        const errorMessage = error.message.split("\n")[0];
        setAlert(errorMessage);
      });
  };

  let toggleChecked = (rowData) => {
    if (activeSite) {
      toggleCheckedSite(rowData);
    }
    if (activeLob) {
      toggleCheckedLob(rowData);
    }
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    if (rowData?.locationId) {
      setAnchorSelected(rowData.locationId);
    }
    if (rowData?.lobid) {
      setAnchorSelected(rowData.lobid);
    }
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  const showStates = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            width: "50%",
            justifyContent: "flex-start",
          }}
        >
          {user && (
            <TableConvention>
              <div
                style={{
                  background: "rgba(191, 191, 191, 1)",
                  height: "1em",
                  width: "1em",
                  borderRadius: "7px",
                }}
              ></div>
              <p>Disable</p>
              <div
                style={{
                  background: "rgba(4, 180, 105, 1)",
                  height: "1em",
                  width: "1em",
                  borderRadius: "7px",
                }}
              ></div>
              <p>Active</p>
            </TableConvention>
          )}
        </div>
      </>
    );
  };

  const tablePaginationListView = (props) => {
    const computedProps = { ...props };
    computedProps.style = {
      ...(computedProps?.style ?? {}),
      borderBottom: "0px",
    };
    return (
      <>
        <div style={{ display: "flex", marginTop: "1rem" }}>
          {showStates()}
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <table>
              <tbody>
                <tr>
                  <TablePagination {...computedProps} />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={`Are you sure you want to delete this ${activeLob ? "lob" : ""}${
          activeSite ? "location" : ""
        }?`}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={handleOptionsForDelete}
      />
    ) : null;
  };

  const showLocationForm = (trigger) => {
    if (trigger === "location") {
      return (
        <PortalModal>
          <SitesCreationForm
            user={user}
            setFormTrigger={setFormTrigger}
            editRowData={editRowData}
            setReloadRender={setReloadRender}
          />
        </PortalModal>
      );
    }
  };

  const showLobCreationForm = (trigger) => {
    if (trigger === "lobUpdate") {
      return (
          <LobCreationForm
          user={user}
          setFormTrigger={setFormTrigger}
          editRowData={editRowData}
          reloadRender={reloadRender}
          setReloadRender={setReloadRender}
        />
      );
    }
  };

  return (
    <GeneralStyle>
      {showLobCreationForm(formTrigger)}
      {formTrigger !== "lobUpdate" && (
        <div className={classes.titleAlignment}>
          <h6 className={classes.titleOfList}>{titleOfTable}</h6>
          <ActionSection>
            <div className="right-section">
              {valueTab === 0 &&
                userComplete.roleId !== ROLES.COUNTRY_ADMIN && (
                  <Form.Select value={country} onChange={handleCountryChange}>
                    <option value="">Select a Country</option>
                    {countries?.countryLocationList.map((country) => (
                      <option key={country.countryId} value={country.countryId}>
                        {country.countryName}
                      </option>
                    ))}
                  </Form.Select>
                )}

              <SearchField style={{ marginLeft: "20px" }}>
                <SearchIcon />
                <Form.Control
                  type="text"
                  placeholder="Search"
                  value={searchTxt}
                  onChange={(e) => {
                    if (e.target.value) {
                      setSearchTxt(e.target.value);
                    } else {
                      setSearchTxt("");
                    }
                  }}
                  onBlur={() => setrenderAgain(!renderAgain)}
                />
              </SearchField>
              <div className="table-action">
                <Tooltip title="View List">
                  <TableViewButton
                    iconColor={showCards}
                    onClick={() => setShowCards(false)}
                    className="MuiButtonBase-root MuiIconButton-root"
                  >
                    <span
                      style={{ width: "fit-content" }}
                      className="MuiIconButton-label"
                    >
                      <ViewList className="list-view" />
                    </span>
                  </TableViewButton>
                </Tooltip>
                <Tooltip title="View Cards">
                  <TableViewButton
                    iconColor={showCards}
                    onClick={() => setShowCards(true)}
                    style={{ borderLeft: "none" }}
                    className="MuiButtonBase-root MuiIconButton-root"
                  >
                    <span
                      style={{ width: "fit-content" }}
                      className="MuiIconButton-label"
                    >
                      <ViewCards className="card-view" />
                    </span>
                  </TableViewButton>
                </Tooltip>
              </div>
            </div>
          </ActionSection>
        </div>
      )}
      {((loadingLobsList && !errorLobsList) ||
        (loadingChangeStateSite && !errorChangeStateSite) ||
        loadingCanIDisableLobs ||
        (loadingLocations && !errorLocations)) && (
        <Row>
          <Col md="12" className="d-flex justify-content-center mt-5">
            <PointersLine color={themeConfig.text.primary} />
          </Col>
        </Row>
      )}
      {((loadingUpdateLobStatus && !errorUpdateLobStatus) ||
        (loadingDeleteLob && !errorDeleteLob) ||
        loadingCanIDisableLobs) && <ModalLoader />}
      {((!loadingLobsList && errorLobsList) ||
        (!loadingLocations && errorLocations)) && (
        <Row>
          <Col md="12" className="d-flex justify-content-center mt-5">
            <h1>Error :(</h1>
          </Col>
        </Row>
      )}
      {formTrigger !== "lobUpdate" &&
        ((!loadingLobsList && !errorLobsList) ||
          (!loadingLocations && !errorLocations)) && (
          <div>
            <Snackbar open={open} autoHideDuration={1200} onClose={handleClose}>
              {alert ? (
                <Alert onClose={handleClose} severity="success">
                  The link was generated correctly
                </Alert>
              ) : (
                <Alert onClose={handleClose} severity="error">
                  The link was not generated, please try again
                </Alert>
              )}
            </Snackbar>
            {!showCards &&
              !loadingLobsList &&
              !loadingUpdateLobStatus &&
              !loadingDeleteLob &&
              !loadingCanIDisableLobs &&
              !loadingChangeStateSite &&
              !loadingLocations &&
              Array.isArray(dataList) &&
              dataList.length > 0 && (
                <MaterialTable
                  style={{ boxShadow: "none", margin: "0 10px 1rem" }}
                  title=""
                  columns={columns
                    .map((item) => ({ ...item }))
                    .filter((item) => {
                      if (activeSite) {
                        return item.title !== "";
                      }
                      if (activeLob) {
                        return item.title !== "";
                      }
                    })}
                  data={dataList}
                  options={{
                    headerStyle: {
                      zIndex: 0,
                      fontWeight: "bold",
                      backgroundColor: themeConfig.neutral.gray[800],
                    },
                    cellStyle: {
                      padding: "5px 10px",
                    },
                    rowStyle: (rowData) => ({
                      backgroundColor:
                        rowData.tableData.id % 2 === 0 ? "#F0F0F0" : "#FFF",
                    }),
                    search: false,
                    paging: false,
                  }}
                  components={{
                    Pagination: tablePaginationListView,
                  }}
                ></MaterialTable>
              )}
            {showCards &&
              !loadingLobsList &&
              !loadingUpdateLobStatus &&
              !loadingDeleteLob &&
              !loadingChangeStateSite &&
              !loadingCanIDisableLobs &&
              !loadingLocations &&
              Array.isArray(dataList) &&
              dataList.length > 0 && (
                <>
                  <ViewControlMenu
                    className="mt-5"
                    identity={identity}
                    showCards={showCards}
                    setShowCards={setShowCards}
                    list={dataList}
                    isAgent={false}
                    toggleChecked={toggleChecked}
                    handleClickActions={handleClickActions}
                    anchorSelected={anchorSelected}
                    anchorEl={anchorEl}
                    handleCloseActions={handleCloseActions}
                    handleEditEvent={handleEdit}
                    setAnchorEl={setAnchorEl}
                    setAnchorSelected={setAnchorSelected}
                    setOpenDeleteModal={setOpenDeleteModal}
                    hideCategoryButtons={true}
                  />
                </>
              )}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "10vw",
              }}
              hidden={
                loadingLobsList ||
                loadingUpdateLobStatus ||
                loadingDeleteLob ||
                loadingChangeStateSite ||
                loadingCanIDisableLobs ||
                loadingLocations ||
                (Array.isArray(dataList) && dataList.length > 0)
              }
            >
              <p>No records to display</p>
            </div>
            <div style={{ display: "flex", padding: "0 10px" }}>
              {showStates()}
              {allPages > 0 && rowsPerPage && rowsPerPageOptions ? (
                <TablePagination
                  component="div"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "50%",
                  }}
                  count={allPages}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={rowsPerPageOptions}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        )}
      <br />
      <br />
      {showDeleteModal()}
      {showLocationForm(formTrigger)}
    </GeneralStyle>
  );
};

export default DataManagementList;

DataManagementList.propTypes = {
  activeLob: PropTypes.bool,
  activeSite: PropTypes.bool,
  reloadRender: PropTypes.bool,
  setReloadRender: PropTypes.func,
  formTrigger: PropTypes.string,
  setFormTrigger: PropTypes.func,
  valueTab: PropTypes.number,
};
